module.exports = __webpack_public_path__ + "img/logo-text.e5b84abe.png";